/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons/index.js";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js"
import { colors } from "../../../constants/colors.js";

const Content = props => {
  const { handleConfirm, handleCancelConfirm, modalContent } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const handleConfirmSubmit = () => {
    handleConfirm()
  }

  const handleCancel = () => {
    handleCancelConfirm()
  }

  return (
    <div className={classes.modalContent}>
      {modalContent}
      <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row className={classes.btnsRow}>
            <Col className={classes.colCancel}>
              <UCButton
                onClick={handleCancel}
                type="default"
                className={classes.cancelBtn}
                text={<FormattedMessage id="confirmAssignModal.cancel"/>}
              />
            </Col>
            <Col className={classes.colRemove} >
              <UCButton
                className={classes.createBtn}
                onClick={handleConfirmSubmit}
                type="primary"
                text={<FormattedMessage id="confirmAssignModal.confirm"/>}
                spinner={{
                  name: "confirmAssignSpinner",
                  size: 20,
                  color: colors.white
                }}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  )
}

export default Content;
